const findFirstLetters = (firstname: string, lastname: string) => {
  const firstLetterFirstname = firstname.slice(0, 1).toUpperCase()
  const firstLetterLastname = lastname.slice(0, 1).toUpperCase()
  return `${firstLetterFirstname}${firstLetterLastname}`
}

export default findFirstLetters
